import { atom, selector } from 'recoil'
import AgoraRTC from 'agora-rtc-sdk-ng'

export const APP_ID = '0c7e9a4a81414db2959d3def8a680cf3'

export const usersState = atom({
  key: 'agora/users',
  default: [],
})

export const joinedState = atom({
  key: 'agora/joined',
  default: undefined,
})

export const userMuteState = atom({
  key: 'agora/user-mute',
  default: true,
})

export const clientState = atom({
  key: 'agora/client',
  default: AgoraRTC.createClient({ mode: "rtc", codec: "vp8" }),
})

// export const localAudioTrackState = selector({
//   key: 'agora/local-tracks',
//   get: async () => await AgoraRTC.createMicrophoneAudioTrack(),
// })

export const remoteUsersState = selector({
  key: 'agora/remote-users',
  get: ({get}) => {
    const client = get(clientState)
    return client.remoteUsers
  },
})
